
import { Component, Vue, Watch } from "vue-property-decorator";
import ConquestService from "@/services/auth/ConquestService";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import { Money } from 'v-money';
import vSelect from "vue-select";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import "datatables.net-buttons-bs4";

@Component({
  components: {
    LayoutDefault,
    Money,
    vSelect
  }
})
export default class Conquest extends Vue {
  private loading = false;

  private myAchievements: any[] = [];
  private conquering: any[] = [];
  private futureAchievements: any[] = [];

  private myAchievementsTotal = 0;
  private conqueringTotal = 0;
  private futureAchievementsTotal = 0;

  private conqueredHistory: any[] = [];
  private nameConquest: any = null;
  private iconConquest: any = null;

  private conqueredArrayPositions: any[] = [];

  private moreAchievements(achievement) {
    const myAchievementsAfterSix     = document.querySelectorAll('#myAchievementsAfterSix');
    const conqueringAfterSix         = document.querySelectorAll('#conqueringAfterSix');
    const futureAchievementsAfterSix = document.querySelectorAll('#futureAchievementsAfterSix');
    const achievementsListId         = document.querySelectorAll('#achievementsList');

    const myAchievementsClass     = document.querySelectorAll('.myAchievements');
    const conqueringClass         = document.querySelectorAll('.conquering');
    const futureAchievementsClass = document.querySelectorAll('.futureAchievements');

    if(achievement.list == 'myAchievements') {
      myAchievementsAfterSix.forEach(item => {
        item['style'].display = '';
      });

      this.displayNone(['conquering', 'futureAchievements'], myAchievementsClass, conqueringClass, futureAchievementsClass);

      achievementsListId[0]['style'].height = '81vh';

      this.moreAchievementsTwo('none', achievement.list);
      this.lessAchievementsTwo('', achievement.list);

    } else if(achievement.list == 'conquering') {
      conqueringAfterSix.forEach(item => {
        item['style'].display = '';
      });

      this.displayNone(['myAchievements', 'futureAchievements'], myAchievementsClass, conqueringClass, futureAchievementsClass);

      achievementsListId[1]['style'].height = '81vh';

      this.moreAchievementsTwo('none', achievement.list);
      this.lessAchievementsTwo('', achievement.list);
    } else if(achievement.list == 'futureAchievements') {
      futureAchievementsAfterSix.forEach(item => {
        item['style'].display = '';
      });

      this.displayNone(['myAchievements', 'conquering'], myAchievementsClass, conqueringClass, futureAchievementsClass);

      achievementsListId[2]['style'].height = '81vh';

      this.moreAchievementsTwo('none', achievement.list);
      this.lessAchievementsTwo('', achievement.list);
    }
  }

  private lessAchievements(achievement) {
    const myAchievementsAfterSix     = document.querySelectorAll('#myAchievementsAfterSix');
    const conqueringAfterSix         = document.querySelectorAll('#conqueringAfterSix');
    const futureAchievementsAfterSix = document.querySelectorAll('#futureAchievementsAfterSix');
    const achievementsListId         = document.querySelectorAll('#achievementsList');

    const myAchievementsClass     = document.querySelectorAll('.myAchievements');
    const conqueringClass         = document.querySelectorAll('.conquering');
    const futureAchievementsClass = document.querySelectorAll('.futureAchievements');

    if(achievement.list == 'myAchievements') {
      myAchievementsAfterSix.forEach(item => {
        item['style'].display = 'none';
      });

      this.displayNull(['conquering', 'futureAchievements'], myAchievementsClass, conqueringClass, futureAchievementsClass);

      achievementsListId[0]['style'].height = '25vh';

      this.moreAchievementsTwo('', achievement.list);
      this.lessAchievementsTwo('none', achievement.list);
    } else if(achievement.list == 'conquering') {
      conqueringAfterSix.forEach(item => {
        item['style'].display = 'none';
      });

      this.displayNull(['myAchievements', 'futureAchievements'], myAchievementsClass, conqueringClass, futureAchievementsClass);

      achievementsListId[1]['style'].height = '25vh';

      this.moreAchievementsTwo('', achievement.list);
      this.lessAchievementsTwo('none', achievement.list);
    } else if(achievement.list == 'futureAchievements') {
      futureAchievementsAfterSix.forEach(item => {
        item['style'].display = 'none';
      });

      this.displayNull(['myAchievements', 'conquering'], myAchievementsClass, conqueringClass, futureAchievementsClass);

      achievementsListId[2]['style'].height = '25vh';

      this.moreAchievementsTwo('', achievement.list);
      this.lessAchievementsTwo('none', achievement.list);
    }
  }

  private increaseCard() {
    //border-top-right-radius: 0;
    //border-bottom-right-radius: 0;
    //clip-path: inset(0.5vw 0 -2vh -2vh);
    //width: 18vw;
  }

  private dencreaseCard() {
    //border-top-left-radius: 0;
  }

  private displayNull(values, myAchievementsClass, conqueringClass, futureAchievementsClass) {
    values.forEach(item => {
      if(item == 'myAchievements') {

        myAchievementsClass[0]['style'].display = '';

      } else if(item == 'conquering') {

        conqueringClass[0]['style'].display = '';

      } else if(item == 'futureAchievements') {

        futureAchievementsClass[0]['style'].display = '';
      }
    });
  }

  private displayNone(values, myAchievementsClass, conqueringClass, futureAchievementsClass) {
    values.forEach(item => {
      if(item == 'myAchievements') {

        myAchievementsClass[0]['style'].display = 'none';

      } else if(item == 'conquering') {

        conqueringClass[0]['style'].display = 'none';

      } else if(item == 'futureAchievements') {

        futureAchievementsClass[0]['style'].display = 'none';
      }
    });
  }

  private moreAchievementsTwo(status, list) {
    if(list == 'myAchievements') {
      const moreMyAchievementsClass = document.querySelectorAll('.moreMyAchievements');

      if(status == 'none') {
        moreMyAchievementsClass[0]['style'].display = 'none';
      } else {
        moreMyAchievementsClass[0]['style'].display = '';
      }
    } else if(list == 'conquering') {
      const moreConqueringClass = document.querySelectorAll('.moreConquering');

      if(status == 'none') {
        moreConqueringClass[0]['style'].display = 'none';
      } else {
        moreConqueringClass[0]['style'].display = '';
      }
    } else if(list == 'futureAchievements') {
      const moreFutureAchievementsClass = document.querySelectorAll('.moreFutureAchievements');

      if(status == 'none') {
        moreFutureAchievementsClass[0]['style'].display = 'none';
      } else {
        moreFutureAchievementsClass[0]['style'].display = '';
      }
    }
  }

  private lessAchievementsTwo(status, list) {
    if(list == 'myAchievements') {
      const lessMyAchievementsClass = document.querySelectorAll('.lessMyAchievements');

      if(status == 'none') {
        lessMyAchievementsClass[0]['style'].display = 'none';
      } else {
        lessMyAchievementsClass[0]['style'].display = '';
      }
    } else if(list == 'conquering') {
      const lessConqueringClass = document.querySelectorAll('.lessConquering');

      if(status == 'none') {
        lessConqueringClass[0]['style'].display = 'none';
      } else {
        lessConqueringClass[0]['style'].display = '';
      }
    } else if(list == 'futureAchievements') {
      const lessFutureAchievementsClass = document.querySelectorAll('.lessFutureAchievements');

      if(status == 'none') {
        lessFutureAchievementsClass[0]['style'].display = 'none';
      } else {
        lessFutureAchievementsClass[0]['style'].display = '';
      }
    }
  }

  private async mounted(){
    const conquestService = new ConquestService();
    this.loading = true;

    try {
      this.myAchievements = await conquestService.indexConquest('achievements', this.$auth.user().id_user, this.$auth.user().id_platform);
      this.conquering = await conquestService.indexConquest('conquering', this.$auth.user().id_user, this.$auth.user().id_platform);
      this.futureAchievements = await conquestService.indexConquest('toConquer', this.$auth.user().id_user, this.$auth.user().id_platform);
    } catch (error) {
      this.loading = false;
    }

    this.myAchievementsTotal = this.myAchievements.length;
    this.conqueringTotal = this.conquering.length;
    this.futureAchievementsTotal = this.futureAchievements.length;
    this.loading = false;
  }

  private async showModal(conquest_id, title, url_icon) {
    const conquestService = new ConquestService();

    try {
      this.nameConquest = title;
      this.iconConquest = url_icon;
      this.conqueredHistory = await conquestService.indexHistoryConquest(conquest_id, this.$auth.user().id_user, this.$auth.user().id_platform);

      let conqueredHistoryTotal = this.conqueredHistory.length;
      let position = conqueredHistoryTotal;

      for(let i = 0; i < conqueredHistoryTotal; i++){
        this.conqueredArrayPositions[i] = position;
        position = position - 1;
      }

      this.$bvModal.show('modal-history');
    } catch (error) {
      console.error(error);
    }
  }

  private hideModal() {
    this.$bvModal.hide('modal-history');
  }
}
